var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-teacher-subscribe-audit" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        staticClass: "standard-size-16 color-gray-10",
      },
      [
        _c(
          "div",
          { staticClass: "mb24 font-bolder" },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("pc_signup_tit_applicant" /* 申请人信息 */)) +
                "\n      "
            ),
            _c(
              "yxtf-row",
              {
                staticClass: "mv24 font-normal font-size-14",
                attrs: { type: "flex" },
              },
              [
                _c(
                  "yxtf-col",
                  {
                    staticClass: "nowrap mh2 felx-center",
                    attrs: { span: 12 },
                  },
                  [
                    _c("span", { staticClass: "color-gray-7" }, [
                      _vm._v(
                        _vm._s(_vm.$t("pc_biz_signup_lbl_name" /* 姓名 */)) +
                          "："
                      ),
                    ]),
                    _c(
                      "yxtf-tooltip",
                      { attrs: { "open-filter": true, placement: "top" } },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _c(
                              "span",
                              [
                                _c("yxtbiz-user-name", {
                                  attrs: { name: _vm.baseInfo.teName || "--" },
                                }),
                                _vm._v(
                                  "（" +
                                    _vm._s(_vm.baseInfo.teUserName || "--") +
                                    "）\n              "
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "yxtbiz-teacher-enroll-audit_ellipsis",
                          },
                          [
                            _c(
                              "span",
                              [
                                _c("yxtbiz-user-name", {
                                  attrs: { name: _vm.baseInfo.teName || "--" },
                                }),
                                _vm._v(
                                  "（" +
                                    _vm._s(_vm.baseInfo.teUserName || "--") +
                                    "）\n              "
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "yxtf-col",
                  {
                    staticClass: "nowrap mh2 felx-center",
                    attrs: { span: 12 },
                  },
                  [
                    _c("span", { staticClass: "color-gray-7" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("pc_biz_signup_lbl_deptname" /* 部门 */)
                        ) + "："
                      ),
                    ]),
                    _c(
                      "yxtf-tooltip",
                      { attrs: { "open-filter": true, placement: "top" } },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _c("yxtbiz-dept-name", {
                              attrs: { name: _vm.baseInfo.teDeptName || "--" },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "yxtbiz-teacher-enroll-audit_ellipsis",
                          },
                          [
                            _c("yxtbiz-dept-name", {
                              attrs: { name: _vm.baseInfo.teDeptName || "--" },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "mb24 font-bolder" },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("pc_biz_te_lbl_subscribe_info" /* 预约信息 */)) +
                "\n      "
            ),
            _c(
              "yxtf-row",
              {
                staticClass: "mv24 font-normal font-size-14",
                attrs: { type: "flex" },
              },
              [
                _c(
                  "yxtf-col",
                  {
                    staticClass: "nowrap mh2 felx-center",
                    attrs: { span: 12 },
                  },
                  [
                    _c("span", { staticClass: "color-gray-7" }, [
                      _vm._v(
                        _vm._s(_vm.$t("pc_biz_survey_lbl_name" /* 名称 */)) +
                          "："
                      ),
                    ]),
                    _vm.baseInfo.targetName
                      ? _c(
                          "yxtf-tooltip",
                          {
                            attrs: {
                              "open-filter": true,
                              content: _vm.baseInfo.targetName,
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "yxtbiz-teacher-subscribe-audit_ellipsis",
                              },
                              [_vm._v(_vm._s(_vm.baseInfo.targetName))]
                            ),
                          ]
                        )
                      : _c("div", [_vm._v("--")]),
                  ],
                  1
                ),
                _c(
                  "yxtf-col",
                  {
                    staticClass: "nowrap mh2 felx-center",
                    attrs: { span: 12 },
                  },
                  [
                    _c("span", { staticClass: "color-gray-7" }, [
                      _vm._v(
                        _vm._s(_vm.$t("pc_biz_survey_lbl_type" /* 类型 */)) +
                          "："
                      ),
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(_vm.getTargetType(_vm.baseInfo.targetType)) ||
                            "--"
                        )
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _c(
              "yxtf-row",
              {
                staticClass: "mb24 font-normal font-size-14",
                attrs: { type: "flex" },
              },
              [
                _c(
                  "yxtf-col",
                  {
                    staticClass: "nowrap mh2 felx-center",
                    attrs: { span: 12 },
                  },
                  [
                    _c("span", { staticClass: "color-gray-7" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("pc_biz_te_subscribe_time" /* 预约时段 */)
                        ) + "："
                      ),
                    ]),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          (_vm.baseInfo.apptStartDate || "--") +
                            " ~ " +
                            (_vm.baseInfo.apptEndDate || "--")
                        )
                      ),
                    ]),
                  ]
                ),
                _c(
                  "yxtf-col",
                  {
                    staticClass: "nowrap mh2 felx-center",
                    attrs: { span: 12 },
                  },
                  [
                    _c("span", { staticClass: "color-gray-7" }, [
                      _vm._v(
                        _vm._s(_vm.$t("pc_biz_te_lbl_progress" /* 进度 */)) +
                          "："
                      ),
                    ]),
                    _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            "(" +
                              (_vm.baseInfo.passFormalNums || 0) +
                              " / " +
                              (_vm.baseInfo.maxApptNums || 0) +
                              ")"
                          ) +
                          " "
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _c(
              "yxtf-row",
              {
                staticClass: "font-normal font-size-14",
                attrs: { type: "flex" },
              },
              [
                _c(
                  "yxtf-col",
                  {
                    staticClass: "nowrap mh2 felx-center",
                    attrs: { span: 12 },
                  },
                  [
                    _c("span", { staticClass: "color-gray-7" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("pc_biz_ote_lbl_principal" /* 负责人 */)
                        ) + "："
                      ),
                    ]),
                    _vm.baseInfo.directors
                      ? _c(
                          "yxtf-tooltip",
                          {
                            attrs: {
                              "open-filter": true,
                              content: _vm.baseInfo.directors,
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "yxtbiz-teacher-subscribe-audit_ellipsis",
                              },
                              [_vm._v(_vm._s(_vm.baseInfo.directors))]
                            ),
                          ]
                        )
                      : _c("div", [_vm._v("--")]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "font-bolder" },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("pc_biz_lbl_course_detail" /* 课程详情 */)) +
                "\n      "
            ),
            _c(
              "yxtf-row",
              {
                staticClass: "mv24 font-normal font-size-14",
                attrs: { type: "flex" },
              },
              [
                _vm.baseInfo.targetId
                  ? _c("yxtbiz-flip-info", {
                      attrs: { taskId: _vm.baseInfo.targetId },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }